import { EducationalPathVersionMaintenanceDTO } from "../../dto/educational-path/educational-path-version-maintenance.dto";

export class EducationalPathVersionMaintenance {
    constructor(
        public id: number,
        public version_id: number,
        public module_id: number | null,
        public subtype_id: number | null,
        public module_version_id: number | null,
        public subtype_version_id: number | null,
        public required: boolean,
        public start_date: string,
        public end_date: string,
        public created_at: string,
        public updated_at: string,
        public item_details: any, // Module or subtype details
        public version_details: any, // Version-specific details
        public maintenance_minutes: number
    ) {}

    static fromDTO(dto: EducationalPathVersionMaintenanceDTO): EducationalPathVersionMaintenance {
        return new EducationalPathVersionMaintenance(
            dto.id,
            dto.version_id,
            dto.module_id,
            dto.subtype_id,
            dto.module_version_id,
            dto.subtype_version_id,
            dto.required,
            dto.start_date,
            dto.end_date,
            dto.created_at,
            dto.updated_at,
            dto.item_details,
            dto.version_details,
            dto.maintenance_minutes
        );
    }

    toDTO(): EducationalPathVersionMaintenanceDTO {
        return {
            id: this.id,
            version_id: this.version_id,
            module_id: this.module_id,
            subtype_id: this.subtype_id,
            module_version_id: this.module_version_id,
            subtype_version_id: this.subtype_version_id,
            required: this.required,
            start_date: this.start_date,
            end_date: this.end_date,
            created_at: this.created_at,
            updated_at: this.updated_at,
            item_details: this.item_details,
            version_details: this.version_details,
            maintenance_minutes: this.maintenance_minutes
        };
    }
} 